import { useState, useEffect } from 'react';

let subscribers: ((event: any) => void)[] = [];

const emit = (eventName: string, data: any) => {
  subscribers.forEach(callback => callback({ eventName, data }));
};

const subscribe = (callback: (event: any) => void) => {
  subscribers.push(callback);
  return () => {
    subscribers = subscribers.filter(cb => cb !== callback);
  };
};

const useEventSystem = () => {
  const [event, setEvent] = useState<{ eventName: string; data: any } | null>(null);

  useEffect(() => {
    return subscribe((newEvent) => setEvent(newEvent));
  }, []);

  return { event, emit };
};

export default useEventSystem;